import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { validaLargoPayment } from "../../utils/validateData";
import { ArrowDownRightIcon, ArrowUpRightIcon } from "@heroicons/react/24/outline";
import { DisclosureLastActivity } from "../navigation/disclosure/LastActivity";



export function LastActivityComponent(props) {

    const [lastActivity, setLastActivity] = useState([]);
    const lastActivityRef = useRef(lastActivity);
    lastActivityRef.current = lastActivity;

    const determineOperator = (name = "", payValue) => {
        let payFormat = validaLargoPayment(payValue);
        let USDollar = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        });
        let operator = "";
        if (name === "Firmaste los documentos") {
            operator = <span>+{USDollar.format(payFormat).split(".")[0]} </span>;
        } else {
            operator = <span>-{USDollar.format(payFormat).split(".")[0]}</span>;
        }
        return operator;
    };

    const determineIconMovements = (name = "") => {
        let html = "";
        if (name === "Firmaste los documentos") {
            html =<div className="mr-2 grid content-center justify-center w-8 h-8 bg-greenLight rounded-lg font-bold"><ArrowDownRightIcon className="w-4 h-4 text-green font-bold" /></div> ;
        } else {
            html = <div className="mr-2 grid content-center justify-center w-8 h-8 bg-redBgLight rounded-lg font-bold"><ArrowUpRightIcon className="w-4 h-4 text-red font-bold" /></div>;
        }
        return html;
    };

    // Run once on mount only: reads the current value via ref to avoid re-running this effect
    // every time setLastActivity fires (JSON.parse always returns a new array reference), which
    // would otherwise cause an infinite render loop.
    useEffect(() => {
        let _lastActivity = [];
        try {
            _lastActivity = JSON.parse(localStorage.getItem("lastActivity"));
            if (lastActivityRef.current) return setLastActivity(_lastActivity);
        } catch (error) {
            console.log(error);
        }
    }, []);

    return (
        <>
            {
                <DisclosureLastActivity
                    device={"desktop"}
                />
            }

            <div className="h-60 pt-2">
                <div className="block">
                    {(lastActivity ?? []).length === 0 ? (
                        <span className="block">
                            No tienes movimientos registrados.
                        </span>
                    ) : (
                        (lastActivity ?? []).map((activity, idx) => {
                            return (
                                <div key={`${idx}-div-root-1`} className="py-1">
                                    <div>
                                        <div>
                                            <div
                                                key={`${idx}-div1`}
                                                className="flex justify-between text-sm font-bold w-full"
                                            >
                                                <div className="flex">
                                                    <div className="h-full grid content-center">
                                                        
                                                            {determineIconMovements(
                                                                activity?.activity?.name
                                                            )}
                                                    
                                                    </div>
                                                    <div className="block">
                                                        <div>
                                                            {activity?.activity?.name ?? ""}
                                                        </div>
                                                        <div
                                                            key={`${idx}-div2`}
                                                            className="text-grayP text-sm font-normal"
                                                        >
                                                            <span>
                                                                {moment(
                                                                    activity?.activity?.activityDate,
                                                                    "DD/MM/YYYY HH:mm:ss"
                                                                ).format("DD/MM/YYYY")}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {determineOperator(
                                                    activity?.activity?.name,
                                                    activity?.activity?.payValue
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </>
    )
}